import { useCallback, useEffect, useRef, useState } from "react";
import axios, { CancelTokenSource } from "axios";

export default function useCancelToken() {
  const axiosSource = useRef<CancelTokenSource>(null);
  const cancelToken = useCallback(() => {
    axiosSource.current = axios.CancelToken.source();
    return axiosSource.current.token;
  }, []);

  const cancelRequest = () => axiosSource.current?.cancel();

  return { cancelToken, cancelRequest };
}
